.watchlistRow {
  [data-entity-header-watchlist] {
    margin-bottom: 0;
  }
}
